import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bcb79a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tech-container" }
const _hoisted_2 = { class: "right-container" }
const _hoisted_3 = {
  "data-wow-duration": "1s",
  class: "techtitle animate__fadeInDown wow"
}
const _hoisted_4 = {
  "data-wow-duration": "1s",
  class: "techcontext animate__fadeInUp wow"
}
const _hoisted_5 = { class: "span" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-container" }, null, -1))

import WOW from 'wowjs'
import { onMounted, ref } from "vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'ThirdView',
  setup(__props) {

const isHover = ref(false)
onMounted(() => {
  new WOW.WOW(
    { live: false }
  ).init()

})
const changeIndex = () => {
  sessionStorage.setItem('activeIndex', '/tech')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('TechInnovative')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('techcontent')), 1),
        _createElementVNode("a", {
          href: "/tech",
          class: _normalizeClass(["learnmore", { ' animate__rubberBand': isHover.value }]),
          onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isHover.value = true)),
          onMouseout: _cache[1] || (_cache[1] = ($event: any) => (isHover.value = false)),
          onClick: changeIndex
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('learnmore')), 1)
        ], 34)
      ])
    ]),
    _hoisted_6
  ]))
}
}

})